import { sum } from 'd3-array';

export function layoutGraph(graph, container) {

	const { margins, panels, height } = graph.config;
	const { width } = container.getBoundingClientRect();
	const heightPx = typeof height === 'function' ? height(width) : height;

	// The vertical spacing in pixels in between each panel
	const panelSpacing = 25;

	// Only take into consideration active panels
	const activePanels = panels.filter(panel => panel.config.isActive);

	const availableWidthPx = width - margins[1] - margins[3];
	const availableHeightPx = heightPx - margins[0] - margins[2] - (panels.length - 1) * panelSpacing;

	// Get the total height explicitly apportioned
	const sumExplicitHeights = sum(activePanels.map(panel => panel.config.height === null ? 0 : panel.config.height));

	// Get the remaining height
	const remainingHeight = Math.max(0, 1 - sumExplicitHeights);
	const numPanelsToApportion = activePanels.filter(panel => panel.config.height === null).length;

	// Panels with null height will get an equal share of the remaining height
	const panelHeights = activePanels.map(panel => panel.config.height === null ? remainingHeight / numPanelsToApportion : panel.config.height);

	let y = margins[0];
	const panelLayout = [];

	for (let i = 0, n = panels.length; i < n; i++) {

		if (!panels[i].config.isActive) {
			panelLayout.push(null);
			continue;
		}

		const panelHeightPx = availableHeightPx * panelHeights[i];

		panelLayout.push({
			x: margins[3],
			width: availableWidthPx,
			y: y,
			height: panelHeightPx
		});

		y += (panelHeightPx + panelSpacing);

	}

	return {
		plotAreaX: margins[3],
		plotAreaY: margins[0],
		plotAreaWidth: availableWidthPx,
		plotAreaHeight: heightPx - margins[0] - margins[2],
		width,
		height: heightPx,
		panels: panelLayout,
		xPadding: 1
	};

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/layout-graph.js